export enum PayoutStatus {
    UNKNOWN,
    PAID,
    INTRANSIT,
    CANCELLED,
    FAILED,
    PENDING
}